
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-service",
      function () {
        return require("private-next-pages/terms-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-service"])
      });
    }
  